/**
 * Polyfills for older browsers (Safari 15.2+)
 */

// Object.hasOwn - Safari 15.4+
if (typeof (Object as any).hasOwn !== 'function') {
  (Object as any).hasOwn = (obj: any, prop: PropertyKey) =>
    Object.prototype.hasOwnProperty.call(obj, prop);
}

// Array.prototype.at - Safari 15.4+
if (typeof Array.prototype.at !== 'function') {
  (Array.prototype as any).at = function (index: number) {
    index = Math.trunc(index) || 0;
    if (index < 0) index += this.length;
    if (index < 0 || index >= this.length) return undefined;
    return this[index];
  };
}

// String.prototype.at - Safari 15.4+
if (typeof String.prototype.at !== 'function') {
  (String.prototype as any).at = function (index: number) {
    index = Math.trunc(index) || 0;
    if (index < 0) index += this.length;
    if (index < 0 || index >= this.length) return undefined;
    return this[index];
  };
}

// structuredClone - Safari 15.4+
if (typeof (globalThis as any).structuredClone !== 'function') {
  (globalThis as any).structuredClone = <T>(value: T): T => {
    return JSON.parse(JSON.stringify(value));
  };
}

// Array.prototype.findLast - Safari 15.4+
if (typeof (Array.prototype as any).findLast !== 'function') {
  (Array.prototype as any).findLast = function (callback: any, thisArg: any) {
    for (let i = this.length - 1; i >= 0; i--) {
      if (callback.call(thisArg, this[i], i, this)) {
        return this[i];
      }
    }
    return undefined;
  };
}

// Array.prototype.findLastIndex - Safari 15.4+
if (typeof (Array.prototype as any).findLastIndex !== 'function') {
  (Array.prototype as any).findLastIndex = function (callback: any, thisArg: any) {
    for (let i = this.length - 1; i >= 0; i--) {
      if (callback.call(thisArg, this[i], i, this)) {
        return i;
      }
    }
    return -1;
  };
}

export {};
